<template>

    <div :class="['product-info', `STATUS-${status.visibility.value.toUpperCase()}`]">

        <loading-indicator :loading="isLoading" style="max-height: 100px;"></loading-indicator>

        <template v-if="!isLoading">    

            <div class="heading" @click="isOpen = !isOpen" style="cursor: pointer; justify-content: space-between;">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <span class="material-symbols-outlined">
                        <template v-if="status.visibility.value == 'catalog'">check_circle</template>
                        <template v-else-if="status.visibility.value == 'search'">check_circle</template>
                        <template v-else-if="status.visibility.value == 'none'">error</template>
                    </span>
                    <div style="text-transform: uppercase;">{{  status.visibility.label }}</div>
                </div>
                <span class="material-symbols-outlined" style="transition: transform 0.25s ease; color: inherit; opacity: 0.7;" :style="{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }">
                    expand_more
                </span>
            </div>

            <transition name="section-toggle">
                <div v-show="isOpen" style="margin-top: 16px; padding-top: 16px; border-top: 1px solid rgba(0,0,0,0.05);">
                    <div class="reasons" v-if="status.visibility.reasons.length > 0">
                        <span>Grund: </span>
                        <ul>
                            <li v-for="reason in status.visibility.reasons">
                                {{ reason }}
                            </li>
                        </ul>
                    </div>

                    <template v-if="status.visibility.value !== 'none'">
                        <div class="price"><span>Preis:</span> € {{ formatPoint2Comma(status.price.value) }} ({{ status.price.origin }}) <span class="material-symbols-outlined has-pointer" title="Verfügbare Schnittstellen anzeigen" @click="showModal=true">help</span></div>
                        <div class="productStatus"><span>Produktstatus:</span> {{ status.availability.value }} ({{ status.availability.reason }})</div>
                    </template>
                </div>
            </transition>

            <modal
                title="Verfügbare Schnittstellen"
                :width="480"
                cancel-text="Schließen"
                transition="fadeDown"
                :show-ok="false"
                :is-show="showModal"
                :backdrop-closable="false"
                @close="showModal=false"
                class="vcenter">
    
                    <ul class="sources">
                        <li v-for="source in status.price.sources.filter((src, value) => value != status.price.origin)" key="source.name">{{ source.name }} € {{ formatPoint2Comma(source.value) }}</li>
                    </ul>
    
            </modal>

        </template>


    </div>

</template>


<script>
export default {

    props: {
        productId: {
            type: Number,
            default: null
        },
        siteId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            isLoading: true,
            isOpen: false,
            status: {
                visibility: {
                    value: 'none',
                    reasons: []
                } 
            },
            showModal: false,
        }
    },

    created() {

        this.fetchProductStatus();
    },

    methods: {

        async fetchProductStatus() {
            let url = this.$config.api + `pimProduct/${this.productId}/apopointStatus`;
            if(this.siteId) {
                url += `?site=${this.siteId}`
            }
            const res = await this.axios.get(url);
            this.status = res.data;
            this.isLoading = false;
        }
    }

}


</script>

<style lang="scss" scoped>
.product-info {
  background-color: #eaf5fa;
  border-radius: 3px;
  padding: 16px;
  margin-bottom: 24px;

  &.STATUS-SEARCH .heading .material-symbols-outlined {
      color: orange;
  }
  &.STATUS-NONE .heading .material-symbols-outlined {
      color: red;
  }
  &.STATUS-CATALOG .heading .material-symbols-outlined {
      color: green;
  }

  &.STATUS-NONE .reasons {
    margin-bottom: 0;
  }

  .heading {
    line-height: inherit;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 0;
    font-weight: 600;

    .material-symbols-outlined {
        font-size: 19px;
    }

  }
  .reasons {
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    gap: 0 10px;

    ul {
        font-size: 12px;
        max-width: 640px;
        display: list-item;
        list-style: initial;
        margin: 0 0 0 14px;
        padding: 0;
        border-bottom: none;
        font-style: italic;
        list-style-position: outside; 
        white-space: normal;
        li {
            display: initial;
            padding: initial;
            margin: initial;
        }
    }
  }
  .price {
    display: flex;
    align-items: center;
    gap: 0 6px;

    > span:first-child {
        
    }

    .material-symbols-outlined {
        
        font-size: 14px;
        &:hover {
            transition: color .3s ease;
            color: #5b0808;
        }
    }
  }
  .productStatus {
    > span:first-child {
        
    }
  }
}

ul.sources {
    margin: inherit;
    padding: inherit;
    list-style: inherit;
}

/* transition */
.section-toggle-enter-active {
  animation: sectionExpand 0.25s ease-out;
}

.section-toggle-leave-active {
  animation: sectionExpand 0.2s ease-in reverse;
}

@keyframes sectionExpand {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>